import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Company\XeroContactController::store
* @see app/Http/Controllers/Company/XeroContactController.php:22
* @route '/companies/{company}/xero-contacts'
*/
export const store = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/companies/{company}/xero-contacts',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Company\XeroContactController::store
* @see app/Http/Controllers/Company/XeroContactController.php:22
* @route '/companies/{company}/xero-contacts'
*/
store.url = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return store.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\XeroContactController::store
* @see app/Http/Controllers/Company/XeroContactController.php:22
* @route '/companies/{company}/xero-contacts'
*/
store.post = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Company\XeroContactController::destroy
* @see app/Http/Controllers/Company/XeroContactController.php:39
* @route '/companies/{company}/xero-contacts/{xeroContact}'
*/
export const destroy = (args: { company: string | { id: string }, xeroContact: string | { id: string } } | [company: string | { id: string }, xeroContact: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/companies/{company}/xero-contacts/{xeroContact}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Company\XeroContactController::destroy
* @see app/Http/Controllers/Company/XeroContactController.php:39
* @route '/companies/{company}/xero-contacts/{xeroContact}'
*/
destroy.url = (args: { company: string | { id: string }, xeroContact: string | { id: string } } | [company: string | { id: string }, xeroContact: string | { id: string } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            company: args[0],
            xeroContact: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
        xeroContact: typeof args.xeroContact === 'object'
        ? args.xeroContact.id
        : args.xeroContact,
    }

    return destroy.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace('{xeroContact}', parsedArgs.xeroContact.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\XeroContactController::destroy
* @see app/Http/Controllers/Company/XeroContactController.php:39
* @route '/companies/{company}/xero-contacts/{xeroContact}'
*/
destroy.delete = (args: { company: string | { id: string }, xeroContact: string | { id: string } } | [company: string | { id: string }, xeroContact: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const xeroContacts = {
    store: Object.assign(store, store),
    destroy: Object.assign(destroy, destroy),
}

export default xeroContacts